<script>
	import { Alert } from "sveltestrap";
	export let message;
	const extractErrorMsg = (err) => {
		return Object.values(err).join(" ");
	};
</script>

{#if message}
	<Alert fade={true} color="success" dismissible>{message}</Alert>
{/if}
